import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("\n\n\n\n\n{{outlet}}\n",{ moduleName: "seshy/templates/authenticated/teams/show/projects/index.hbs" })